import { IInfrastructureFromBuilder } from '../../types/newbuilding/transportAccessibility';
import { IApplicationState } from '../../types/redux';

export const getInfrastructureFromBuilder = (state: IApplicationState): IInfrastructureFromBuilder | null => {
  const { transportAccessibility } = state.newbuilding;

  if (!transportAccessibility) {
    return null;
  }

  return transportAccessibility.infrastructure || null;
};
